/*
CustomSchemaProperty - editing schema properties. Two selects - Source (object) and Property (property of object) and Clear button
*/

import { useApolloClient } from "@apollo/client";
//import InputLabel from '@mui/material/InputLabel';
import Grid from "@mui/material/Grid";
import { useEffect, useReducer, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import CustomAutocomplete from "../components/CustomAutocomplete";
import { msg } from "../messages";
import {
  SCHEMAS_QUERY,
  SCHEMA_PROPS_QUERY,
  SCHEMA_PROP_QUERY,
} from "../queries";
import { castToType } from "../utils/misc.js";

const CustomSchemaProperty = (props) => {
  const client = useApolloClient();
  const dispatch = useDispatch();

  const [listOfSources, setListOfSources] = useState([]);
  const [listOfProps, setListOfProps] = useState([]);

  let defaultValues = {};

  // for forms

  const [values, setValues] = useReducer(
    (prev, updated) => ({ ...prev, ...updated }),
    defaultValues
  );

  // get props of device on device selection
  const handleDeviceChange = async (e) => {
    //

    if (e.target.value === "") {
      setListOfProps([]);
      return;
    }

    try {
      const result = await client.query({
        query: SCHEMA_PROPS_QUERY,
        variables: { schemaId: e.target.value },
        fetchPolicy: "network-only",
      });

      setListOfProps(
        result.data.schemaProperties.map((item) => {
          return {
            value: item.id,
            title: `${item.groupName} / ${item.description}`,
          };
        })
      );
    } catch (err) {
      toast.error(err.toString());
    } finally {
    }
  }; //handleDeviceChange

  useEffect(() => {
    const queryProps = async () => {
      try {
        //

        const result_objects = await client.query({
          query: SCHEMAS_QUERY,
          variables: {},
          fetchPolicy: "network-only",
        });

        setListOfSources(
          result_objects.data.schemata.map((item) => {
            return { value: item.id, title: item.name };
          })
        );

        // if there is initial value in db, load list of properties and set current Property select item to it
        if (props.value) {
          // get object id by property id (to set current Source select item)
          const result_objectAndProp = await client.query({
            query: SCHEMA_PROP_QUERY,
            variables: {
              propId: props.value,
            },
            fetchPolicy: "network-only",
          });

          // get list of properties for selected schema (if selected) to fill Property select
          const result_linked_property = await client.query({
            query: SCHEMA_PROPS_QUERY,
            variables: {
              schemaId: result_objectAndProp.data.schemaProperty.schemaId,
            },
            fetchPolicy: "network-only",
          });

          setListOfProps(
            result_linked_property.data.schemaProperties.map((item) => {
              return {
                value: item.id,
                title: `${item.groupName} / ${item.description}`,
              };
            })
          );

          // set current item from list of objects
          defaultValues["source"] =
            result_objectAndProp.data.schemaProperty.schemaId;

          // set current item from list of properties
          defaultValues["property"] = props.value; // property id
        } //if
        else {
          // unset both selects because there is no value in property
          defaultValues["source"] = null;
          defaultValues["property"] = null;
        }

        setValues(defaultValues);
      } catch (err) {
        toast.error(err.toString());
      } finally {
      }
    }; //queryProps

    queryProps();
  }, []);

  useEffect(() => {
    //
    if (props.setButtonSaveDisabled)
      if (values["source"] && !values["property"])
        props.setButtonSaveDisabled(true);
      else props.setButtonSaveDisabled(false);

    /*
    if (!values['source'] || (listOfRpcs.length===0))
      setButtonControlDisabled(true)
    else
      setButtonControlDisabled(false)
  */
  }, [values]);

  const handleInputChange = (e) => {
    let { name, value, checked } = e.target;

    if (name === "source" && value) handleDeviceChange(e);
    if (name === "property") handleInputChangeCasted(e, props.propType);

    // if Source select is empty, reset Property select as well
    if (name === "source" && !value) {
      props.onChange({
        target: { name: "source", value: null, checked: null },
      });
      props.onChange({
        target: { name: "property", value: null, checked: null },
      });
      setValues({ source: null, property: null });
      return;
    }

    if (checked) value = checked;

    setValues({ [name]: value });

    //
  };

  const handleInputChangeCasted = (event, type) => {
    let { name, value, checked } = event.target;

    const e = {
      target: {
        name: props.name,
        value: castToType(value, type),
        checked: checked,
      },
    };

    props.onChange(e);
  };

  return (
    <>
      {/*      <InputLabel htmlFor={`${props.name}-label`} style={{marginBottom:'20px'}}>{props.label}</InputLabel>  */}

      <Grid container direction="column" spacing={2} id={`${props.name}-label`}>
        <Grid item>
          <CustomAutocomplete
            name="source"
            label={msg.editWidgetSourceModal.source}
            list={listOfSources}
            value={values["source"] ?? ""}
            onChange={handleInputChange}
            clearFieldIcon={true}
          />
        </Grid>

        <Grid item>
          <CustomAutocomplete
            name="property"
            label={msg.editWidgetSourceModal.property}
            list={listOfProps}
            value={values["property"] ?? ""}
            onChange={handleInputChange}
            clearFieldIcon={true}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CustomSchemaProperty;
